class Do3dCreatorRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.load(this.controller.signal);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  async load(signal) {
    const grid = this.querySelector('.d3-related-products');
    const panel = this.querySelector('.d3-related-browsing__products');
    const creator = this.dataset.creatorKey;
    if (!grid || !panel || !creator || !this.dataset.vendorUrl) return;
    const ids = new Set([this.dataset.productId, ...Array.from(grid.children, card => card.dataset.productId)]);
    let url = new URL(this.dataset.vendorUrl, location.origin);
    url.searchParams.set('view', 'do3d-creator-cards');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const visited = new Set();
    try {
      while (url && grid.children.length < 4 && !signal.aborted) {
        if (url.origin !== location.origin || visited.has(url.href)) break;
        visited.add(url.href);
        const response = await fetch(url.href, { signal });
        if (!response.ok) throw new Error('Creator recommendations could not load');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('[data-d3-creator-cards]');
        if (!source || signal.aborted || !this.isConnected) return;
        for (const card of source.children) {
          if (card.dataset.d3CreatorKey !== creator || card.dataset.productKind !== this.dataset.productKind || ids.has(card.dataset.productId)) continue;
          ids.add(card.dataset.productId);
          grid.append(document.importNode(card, true));
          if (grid.children.length === 4) break;
        }
        for (const style of html.querySelectorAll('style[data-section-stylesheet]')) {
          const imported = document.importNode(style, true);
          this.append(imported);
        }
        panel.hidden = grid.children.length === 0;
        const next = source.dataset.next;
        url = next ? new URL(next, url) : null;
        if (url) {
          url.searchParams.set('view', 'do3d-creator-cards');
          if (preview) url.searchParams.set('preview_theme_id', preview);
        }
      }
    } catch (error) {
      if (!signal.aborted) console.warn('Creator recommendations unavailable', error);
    }
  }
}

if (!customElements.get('do3d-creator-recommendations')) {
  customElements.define('do3d-creator-recommendations', Do3dCreatorRecommendations);
}
